import {
  Box,
  CircularProgress,
  Container,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import CustomButton from "../../../Components/Button/CustomButton";
import { Link, useNavigate } from "react-router-dom";
import backbluebtn from "../../../Utils/Images/backbluebtn.png";
import CustomInput from "../../../Components/input/CustomInput";
import { handleAddCoupon } from "../../../APIs/Function/Coupon/AddCoupon";
const AddCoupon = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    coupon_code: "",
    description: "",
    discount_type: "",
    discount_value: null,
  });
  const initialFormData = {
    coupon_code: "",
    description: "",
    discount_type: "",
    discount_value: null,
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (
      formData.coupon_code.trim() !== "" &&
      formData.description.trim() !== "" &&
      formData.discount_type &&
      formData.discount_value
    ) {
      try {
        setLoading(true);
        let res = await handleAddCoupon(formData);
        if (res.s) {
          setLoading(false);
          alert("Data Added Succesfully");
          navigate("/coupon");
        }
        setFormData(initialFormData);
      } catch (error) {
        console.log(error);
      }
    } else {
      alert("Please Fill All The Fields Correctly");
    }
  };

  const discountValueOptions =
    formData.discount_type === "2"
      ? ["100", "200", "300"]
      : formData.discount_type === "1"
      ? ["10", "20", "30"]
      : [];

  return (
    <>
      <Box>
        {/* header */}
        <Box
          sx={{
            bgcolor: "#31AEF4",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: { xs: "50px", md: "70px", lg: "70px" },
            p: "10px",
            boxSizing: "border-box",
          }}
        >
          <Link to={`/coupon`}>
            <Box
              sx={{
                height: { xs: "50px", md: "60px", lg: "60px" },
                display: "flex",
                alignItems: "center",
              }}
            >
              <img height={"100%"} src={backbluebtn} alt="back" />
            </Box>
          </Link>
          <Box>
            <Typography
              sx={{
                fontFamily: "Open Sans",
                fontSize: { md: "30px", sm: "20px" },
                fontWeight: 600,
                lineHeight: "36px",
                color: "#FFFFFF",
              }}
            >
              Add Coupon
            </Typography>
          </Box>
          <Box>
            <CustomButton
              onClick={handleSubmit}
              sx={{
                width: { xs: "40px", md: "50px", lg: "80px" },
                height: { xs: "10px", md: "50px", lg: "50px " },
              }}
            >
              {loading ? <CircularProgress></CircularProgress> : "Save"}
            </CustomButton>
          </Box>
        </Box>
        {/* Add Coupon Form */}
        {/* form */}
        <Container maxWidth="sm" sx={{ mt: "30px" }}>
          <form>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <CustomInput
                  label="Coupon code"
                  name="coupon_code"
                  value={formData.coupon_code}
                  onChange={handleInputChange}
                  fullWidth
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <CustomInput
                  label="Description"
                  name="description"
                  value={formData.description}
                  onChange={handleInputChange}
                  fullWidth
                  multiline
                  rows={4}
                  required
                />
              </Grid>

              <Grid item xs={12} sx={{ mt: "15px" }}>
                <FormControl fullWidth required>
                  <InputLabel
                     sx={{
                      backgroundColor: "#FFF",
                    }}
                  >
                    Discount Type
                  </InputLabel>
                  <Select
                    name="discount_type"
                    value={formData.discount_type}
                    onChange={handleInputChange}
                    sx={{ textAlign: "left" }}
                  >
                    <MenuItem value="1">Percentage</MenuItem>
                    <MenuItem value="2">Price</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sx={{ mt: "15px" }}>
                <FormControl fullWidth required>
                  <InputLabel
                    sx={{
                      backgroundColor: "#FFF",
                    }}
                  >
                    Discount Value
                  </InputLabel>
                  <Select
                    name="discount_value"
                    value={formData.discount_value}
                    onChange={handleInputChange}
                    disabled={!formData.discount_type}
                    sx={{ textAlign: "left" }}
                  >
                    {discountValueOptions.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </form>
        </Container>
      </Box>
    </>
  );
};

export default AddCoupon;
